import EVENT_STATUS from 'constants/salon/eventStatus.const';
import TIME_OFF_DURATIONS from 'constants/timeoff/durations.const';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToString from 'utils/converters/fromAnyToString';
import { fromAnyDateToIso, fromAnyDateToIsoDayBgn, fromAnyDateToIsoDayEnd } from 'utils/converters/time/from.util';
import asObject from 'utils/objects/asObject.util';
import constructRecurrenceString from 'utils/recurrence/constructRecurrenceString.util';

// TODO: make this work for update when there is a time off id
const fromTimeOffFormToData = (form) => {
  const rrs = form?.repeat?.id;
  const repeatForever = !form?.repeatUntil;
  const isAllDay = form?.duration === TIME_OFF_DURATIONS.day;

  const day = fromAnyDateToIso(form?.fullDay);
  const bgn = isAllDay ? fromAnyDateToIsoDayBgn(day) : fromAnyDateToIso(form?.block?.from?.value ?? null);
  const end = isAllDay ? fromAnyDateToIsoDayEnd(day) : fromAnyDateToIso(form?.block?.to?.value ?? null);

  return {
    status: EVENT_STATUS.timeOff, // NOTE: hardcoded since this is a time off object
    notes: fromAnyToString(form?.note) || null,
    startTime: bgn,
    endTime: end,
    recurrences: constructRecurrenceString({ rrs, bgn, end: form?.repeatUntil, repeatForever }),
    updateAll: false, // TODO: need to check how we derive the value
    showStylist: false, // TODO: need to check how we derive the value
    timeOffCategoryId: fromAnyToInteger(asObject(form?.category).id),
  };
};

export default fromTimeOffFormToData;
